<template>
  <div>
    <h3 class="pt-2">
      <font-awesome-icon
        icon="store"
        class="mr-1"
        :title="$t('storeName')"
        :aria-label="$t('storeName')"
      />
      {{ $t('storeName') }}
    </h3>
    <p>{{ $configuration.store.name }}</p>

    <template v-if="address && address.location">
      <h3>
        <font-awesome-icon
          icon="truck-fast"
          class="mr-1"
          :title="$t('location')"
          :aria-label="$t('location')"
        />
        {{ address.name }}
      </h3>
      <p>{{ address }}</p>
    </template>

    <template v-if="email && email.email">
      <h3>
        <font-awesome-icon
          icon="envelope"
          class="mr-1"
          :title="$t('emailAddress')"
          :aria-label="$t('emailAddress')"
        />
        {{ email.name }}
      </h3>
      <p>
        <a
          :href="`mailto:${email}?subject='Customer question'`"
          class="underline-link-from-center text-dark"
          >{{ email }}</a
        >
      </p>
    </template>

    <template v-if="phone && phone.phone">
      <h3>
        <font-awesome-icon
          icon="phone"
          class="mr-1"
          :title="$t('phoneNumber')"
          :aria-label="$t('phoneNumber')"
        />
        {{ phone.name }}
      </h3>
      <p>
        <a :href="`tel:${phone}`" class="underline-link-from-center text-dark">{{ phone }}</a>
      </p>
    </template>
  </div>
</template>

<script>
import { getLocationAddress, getLocationEmail, getLocationPhone } from '@/utils';

export default {
  name: 'WCStoreInfo',
  computed: {
    phone() {
      return getLocationPhone(this.$configuration.store);
    },
    address() {
      return getLocationAddress(this.$configuration.store);
    },
    email() {
      return getLocationEmail(this.$configuration.store);
    },
  },
};
</script>
